'use client';

import type { UseFormRegister } from 'react-hook-form';

const inputBaseClass =
  'w-full px-4 py-3 rounded-xl border text-sm text-[#373A36] placeholder-[#b0b3ac] focus:outline-none focus:ring-2 focus:ring-[#00A19B]/20 transition-all motion-reduce:transition-none';

const fieldBorder = (hasError: boolean) =>
  hasError ? 'border-red-400 focus:border-red-500' : 'border-[#E8E8E4] focus:border-[#00A19B]';

type Props = {
  name: string;
  label: string;
  register: UseFormRegister<any>;
  error?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  helperText?: string;
};

export function TextField({
  name,
  label,
  register,
  error,
  type = 'text',
  placeholder,
  required,
  helperText,
}: Props) {
  const fieldId = `field-${name}`;
  const errorId = `${fieldId}-error`;
  const helperId = `${fieldId}-helper`;
  const describedBy = error ? errorId : helperText ? helperId : undefined;

  return (
    <div>
      <label htmlFor={fieldId} className="block text-sm font-semibold text-[#373A36] mb-2">
        {label}
        {required && <span className="text-red-500 font-bold ml-0.5">*</span>}
      </label>
      <input
        id={fieldId}
        type={type}
        placeholder={placeholder}
        aria-invalid={!!error}
        aria-describedby={describedBy}
        className={`${inputBaseClass} ${fieldBorder(!!error)}`}
        {...register(name)}
      />
      {helperText && !error && (
        <p id={helperId} className="mt-1 text-xs text-[#6b6e68]">
          {helperText}
        </p>
      )}
      {error && (
        <p id={errorId} className="mt-1 text-xs text-red-500">
          {error}
        </p>
      )}
    </div>
  );
}
